import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { Classification, ClassificationsState, ClassificationsTypes } from './types';

const INITIAL_STATE: ClassificationsState = {
    data: { classificationsList: [] as Classification[] },
    loading: false,
    hasError: false,
};

const reducer: Reducer<ClassificationsState> = (state: ClassificationsState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case ClassificationsTypes.GET_CLASSIFICATIONS_REQUEST: {
            return { ...state, loading: true, hasError: false, data: { classificationsList: [] as Classification[] } };
        }
        case ClassificationsTypes.GET_CLASSIFICATIONS_SUCCESS: {
            return { ...state, data: { classificationsList: action.payload }, loading: false, hasError: false };
        }
        case ClassificationsTypes.GET_CLASSIFICATIONS_FAILURE:
            return { ...state, loading: false, hasError: true };
        default:
            return state;
    }
};

export default reducer;
